import React from 'react';
import { translate } from '../../../Services/translation';

interface DetailCard {
  product: {
    link: {
      href: string;
    };
    imageUrl: string;
    name: string;
    articleNumber: string;
    extraInfo: any;
    quantityString: string;
    priceInfo: {
      formattedPrice: string;
    };
    totalPrice: string;
    itemBIDPromotionCode?: string;
  };
}

const ProductCard = ({ product }: DetailCard) => {
  return (
    <div className="flex gap-4 border-b-2 border-gray-100 p-4 text-md lg:p-6 [&_span:not(:last-child)]:mb-1 ">
      <a href={product.link.href}>
        <img src={product.imageUrl} className="h-16 w-16 object-cover" />
      </a>
      <div className="text-bold flex flex-col text-xl">
        <a href={product.link.href}>
          <span className="title">{product.name}</span>
        </a>
        <span>
          {translate('product.articleno')} {product.articleNumber}
        </span>
        {product.itemBIDPromotionCode && (
          <span>
            {translate('product.item-bid')}: {product.itemBIDPromotionCode}
          </span>
        )}
        {product.extraInfo &&
          product.extraInfo.items.map((item) => (
            <span key={'order-detail' + item.key}>
              {item.key}: {item.value}
            </span>
          ))}
        <span>
          {translate('general.quantity')}: {product.quantityString}
        </span>
        <span>
          {translate('product.unitprice')}:{' '}
          {product.priceInfo?.formattedPrice}
        </span>
        <span className="text-bold">
          {translate('general.total')}: {product.totalPrice}
        </span>
      </div>
    </div>
  );
};

export default ProductCard;
